// 한국어
export default {
  translation: {
    app_name: 'Ledxo Hub',
    tagline: '취미로 이어지는 커뮤니티',
    nav_explore: '탐색',
    nav_find_folks: '친구 찾기',
    nav_sign_in: '로그인',
    nav_join_free: '무료 가입',
    nav_sign_out: '로그아웃',
    nav_my_profile: '내 프로필',
    nav_notifications: '알림',
    auth_register: '계정 만들기',
    auth_login: '로그인',
    auth_name: '이름',
    auth_email: '이메일 주소',
    auth_password: '비밀번호',
    auth_age: '나이',
    auth_city: '도시',
    auth_building: '아파트 단지 / 건물명',
    auth_country: '국가',
    auth_currency: '통화',
    auth_locale: '언어 및 지역',
    auth_already_have_account: '이미 계정이 있으신가요?',
    auth_no_account: '계정이 없으신가요?',
    postcode_label: '우편번호',
    postcode_placeholder: '예) 06141',
    profile_edit: '프로필 편집',
    profile_bio: '자기소개',
    profile_interests: '관심사',
    profile_location: '위치',
    profile_theme: '테마',
    profile_currency_settings: '통화 및 지역',
    profile_save: '변경사항 저장',
    profile_cancel: '취소',
    group_join: '그룹 참가',
    group_leave: '그룹 나가기',
    group_members: '멤버',
    group_chat: '채팅',
    group_events: '이벤트',
    group_shop: '쇼핑',
    group_campaigns: '캠페인',
    group_about: '소개',
    group_full: '인원 마감',
    group_open: '참가 가능',
    tip_send: '팁 보내기',
    tip_amount: '금액',
    tip_message: '메시지 (선택)',
    wallet_coins: '코인',
    wallet_balance: '잔액',
    tips_earned: '획득',
    event_register: '참가 신청',
    event_unregister: '신청 취소',
    event_ticket_price: '티켓',
    event_free: '무료',
    event_capacity: '정원',
    event_registered: '신청 완료',
    no_results: '결과가 없습니다',
    loading: '로딩 중…',
    error_generic: '오류가 발생했습니다. 다시 시도해 주세요.',
  }
};
